<template>
  <div class="container">
    <header>
      <div class="row">
        <h2 class="page-title">ToDo list</h2>
      </div>
    </header>
    <div class="content">
      <div class="row">
        <div class="col s12 m4 sidebar">
          <sidebar :lists="lists"></sidebar>
        </div>
        <div class="col s12 m8 main">
          <mymain></mymain>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'materialize-css/dist/js/materialize.min.js'
import sidebar from './components/sidebar'
import main from './components/main'

export default {
  computed: {
    lists () {
      return this.$store.getters.lists
    }
  },
  components: {
    sidebar,
    mymain: main
  }
}
</script>

<style lang="scss">
  @import 'normalize.css/normalize.css';
  @import 'materialize-css/dist/css/materialize.min.css';
  body{
    background: url('https://cloudypro.com/wp-content/uploads/2015/05/clouds-background-light.jpg') no-repeat fixed center;
      background-size: cover;
  }

  .sidebar {
    background-color: #b0bec5;
    height: 100%;
    border-right: 1px solid #d4d4d4e0;
    &.col {
      padding: 0;
    }
  }

  .main {
    background-color: #ffffffd5;
    height: 100%;
    overflow: scroll;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .page-title {
    text-align: center;
    font-weight: lighter;
  }

  .content {
    overflow: hidden;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    .row {
      margin-bottom: 0;
      height: 70vh;
    }
  }

  .btn {
    margin-right: 20px;
    height: 27px;
    padding: 0px 8px;
    line-height: 27px;
    &:hover{
      background-color: #ff9d45;
    }
    &:last-child {
      margin-right: 0;
    }
    &-edit {
      background-color: #2979ff;
    }
    &-delete {
      background-color: #e53935;
    }
    &-complete {
      background-color: #00c853;
    }
  }

  @media screen and (max-width: 600px) {
    .sidebar {
      height: auto;
      &.col {
        padding-bottom: 20px;
      }
    }
    .main {
      height: auto;
      overflow: auto;
      box-shadow: none;
      &.col {
        padding-bottom: 30px;
      }
    }
    .container {
      width: 100%;
    }
    .content {
      box-shadow: none;
      &.row {
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue